import React from 'react'
import { Container, Row, Col, Stack } from 'react-bootstrap';
const benefit1 = 'https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/video/Icons/webAR-benefit01.png'
const benefit2 = 'https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/video/Icons/webAR-benefit02.png'
const benefit3 = 'https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/video/Icons/webAR-benefit03.png'
const benefit4 = 'https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/video/Icons/webAR-benefit04.png'
const benefit5 = 'https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/video/Icons/webAR-benefit05.png'
const benefit6 = 'https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/video/Icons/webAR-benefit06.png'

export const BenefitAR = () => {
    return (
        <>
            <Container className="my-5">
                <Row>
                     <Col >
                            <h1 className="text-center fontWeight-800">
                                Here are the Potential Benefits of WebAR
                            </h1>
                            <p className=" text-center text-grey-500 fontSize-20">
                                See your products jump off the screen—WebAR’s benefits are just a click away!
                            </p>
                        </Col>
                </Row>
                <Row className='g-3'>
                    {/* First Column */}
                    <Col   md={4} xs={6} lg={2}>
                        <div className="BenefitContent1">
                            <img src={benefit1} className="img-fluid benefitIcons" alt="ARBenefit-01-futurristic" />
                              <Stack direction='horizontal' className='align-items-center justify-content-center h-50'><p>Easy Accessibility
                            </p></Stack>
                        </div>
                    </Col>
                    {/* Second Column */}
                    <Col   md={4} xs={6} lg={2}>
                        <div className="BenefitContent2">
                            <img src={benefit2} className="img-fluid benefitIcons" alt="ARBenefit-02-futurristic" />
                              <Stack direction='horizontal' className='align-items-center justify-content-center h-50'><p>No App Required
                            </p></Stack>
                        </div>
                    </Col>
                    {/* Third Column */}
                    <Col   md={4} xs={6} lg={2}>
                        <div className="BenefitContent1">
                            <img src={benefit3} className="img-fluid benefitIcons" alt="ARBenefit-03-futurristic" />
                              <Stack direction='horizontal' className='align-items-center justify-content-center h-50'><p>High Engagement
                            </p></Stack>
                        </div>
                    </Col>
                    {/* Fourth Column */}
                    <Col   md={4} xs={6} lg={2}>
                        <div className="BenefitContent2">
                            <img src={benefit4} className="img-fluid benefitIcons" alt="ARBenefit-04-futurristic" />
                              <Stack direction='horizontal' className='align-items-center justify-content-center h-50'><p>Cost-Effective</p></Stack>
                        </div>
                    </Col>
                    {/* Fifth Column */}
                    <Col   md={4} xs={6} lg={2}>
                        <div className="BenefitContent1">
                            <img src={benefit5} className="img-fluid benefitIcons" alt="ARBenefit-05-futurristic" />
                              <Stack direction='horizontal' className='align-items-center justify-content-center h-50'><p>Wide Compatibility
                            </p></Stack>
                        </div>
                    </Col>
                    {/* Sixth Column */}
                    <Col md={4} xs={6} lg={2}>
                        <div className="BenefitContent2">
                            <img src={benefit6} className="img-fluid benefitIcons" alt="ARBenefit-06-futurristic" />
                              <Stack direction='horizontal' className='align-items-center justify-content-center h-50'><p>Real-Time Updates
                            </p></Stack>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
